import _ from "lodash";

import { rem } from "../ui";

export const convertUIMethods = (value: string) => {
  let newData = value;
  const element = ["${addColor(", "${rem("];
  element.forEach((e) => {
    newData = convertUIMethod(newData, e);
  });

  return newData;
};

const convertUIMethod = (data: string, name: string) => {
  let clean = data;

  const getData = (_data: string): boolean => {
    if (!_data.split) {
      return false;
    }

    const first = _data.split(name);

    if (!first[1]) {
      return false;
    }

    return _.isArray(first);
  };

  const getClean = (_data: string) => {
    if (!_data.split) {
      return _data;
    }

    const first = _data.split(name);

    if (!first[1]) {
      return _data;
    }

    const second = first[1].split(")}");
    const value = second[0];

    const getValue = (value: any) => {
      if (name.includes("rem")) {
        return rem(parseInt(value));
      }

      return "";
    };

    return `${_data}`.replace(`${name}${value})}`, getValue(value));
  };

  while (getData(clean)) {
    clean = getClean(clean);
  }

  return clean;
};
